import React from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TListCommunitiesHeaderProps } from 'src/features/Communities/ListCommunities/ListCommunities.types';
import { selectCommunitiesCount } from 'src/redux/communities/communities.selectors';
import { formatter } from 'src/utils/formatter';

import s from './ListCommunities.module.scss';

export const ListCommunitiesHeader: React.FC<TListCommunitiesHeaderProps> = () => {
  const { t } = useTranslation();

  const communitiesCount = useSelector(selectCommunitiesCount);

  return (
    <>
      <div className={s.header}>
        <h2>{t('navigation.MY_COMMUNITIES')}</h2>
        <h3>{formatter.prefixWithZeros(communitiesCount)}</h3>
      </div>
    </>
  );
};
